var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFirmwareUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2.5,
    ry: 2.5,
    stroke: "currentColor",
    strokeWidth: 1.7,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 2.5,
    x2: 8,
    y2: 4,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2.5,
    x2: 12,
    y2: 4,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 2.5,
    x2: 16,
    y2: 4,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 21.5,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 21.5,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 21.5,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 8,
    x2: 4,
    y2: 8,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 12,
    x2: 4,
    y2: 12,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 16,
    x2: 4,
    y2: 16,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 21.5,
    y2: 8,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 21.5,
    y2: 12,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 21.5,
    y2: 16,
    stroke: "currentColor",
    strokeWidth: 1.4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15.5,
    x2: 12,
    y2: 9.5,
    stroke: "#2ECC71",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5L8.8 10.2H15.2L12 7.5Z",
    fill: "#2ECC71"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmwareUpdate);
export default __webpack_public_path__ + "static/media/firmware_update.e410f1cd57522a909ff52d018cf3b867.svg";
export { ForwardRef as ReactComponent };